<script>
    export let h = "h";
    export let r = "r";
</script>

<div>
    <svg viewBox="0 0 300 300" xmlns="http://www.w3.org/2000/svg">
        <defs>
            <marker
                id="seta3"
                viewBox="0 0 16 8"
                refX="0"
                refY="4"
                orient="auto"
                markerUnits="strokeWidth"
                markerWidth="16"
                markerHeight="8"
                style="fill:#000000"
            >
                <path d="M 16,0 L 16,8 L 0,4 L 16,0 z " id="path6997" />
            </marker>
            <marker
                id="seta4"
                viewBox="0 0 16 8"
                refX="16"
                refY="4"
                orient="auto"
                markerUnits="strokeWidth"
                markerWidth="16"
                markerHeight="8"
                style="fill:#000000"
            >
                <path d="M 0,0 L 0,8 L 16,4 L 0,0 z " id="path6994" />
            </marker>
        </defs>
        <g
            id="cota1"
            transform="matrix(1, 0, 0, 0.937429, -121.78981, -29.110329)"
            style="stroke: rgb(0, 0, 0);"
        >
            <line x1="345" y1="80" x2="375" y2="80" id="line7014" />
            <line x1="345" y1="260" x2="375" y2="260" id="line7016" />
            <line
                x1="368"
                y1="80"
                x2="368"
                y2="260"
                id="line7018"
                style="marker-start:url(#seta3);marker-end:url(#seta4)"
            />
        </g>
        <text
            x="259.225"
            y="138.288"
            style="font-size: 18.8px; font-family: Tahoma; white-space: pre;"
            id="text7032">{h}</text
        >
        <line
            stroke-miterlimit="10"
            x1="28.404"
            y1="216.091"
            x2="28.404"
            y2="46.012"
            id="line3"
            style="fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10"
        />
        <ellipse
            stroke-miterlimit="10"
            cx="117.871"
            cy="216.091"
            rx="89.42"
            ry="28.595"
            id="ellipse9"
            style="fill: rgb(0, 0, 213); stroke: rgb(0, 0, 0); stroke-width: 3; stroke-miterlimit: 10; fill-opacity: 0.19; stroke-opacity: 0;"
        />
        <ellipse
            stroke-miterlimit="10"
            cx="117.871"
            cy="46.012"
            rx="89.42"
            ry="28.596"
            id="ellipse11"
            style="fill: rgb(0, 0, 213); stroke: rgb(0, 0, 0); stroke-width: 3; stroke-miterlimit: 10; fill-opacity: 0.18;"
        />
        <line
            stroke-miterlimit="10"
            x1="207.292"
            y1="216.091"
            x2="207.292"
            y2="46.012"
            id="line17"
            style="fill:none;stroke:#000000;stroke-width:3;stroke-miterlimit:10"
        />
        <path
            style="stroke: rgb(0, 0, 0); fill: rgb(0, 0, 213); fill-opacity: 0.185; stroke-opacity: 0;"
            d="M 29.404 51.26 L 28.69 212.633 C 28.69 212.633 36.544 188.96 115.14 187.662 C 193.736 186.364 207.436 212.813 207.436 212.813 L 206.991 52.426 C 206.991 52.426 188.115 73.255 120.561 74.984 C 53.007 76.714 28.83 51.594 29.404 51.26 Z"
        />
        <path
            style="fill: rgb(216, 216, 216); fill-opacity: 0; stroke-dasharray: 12, 4; stroke: rgb(88, 87, 87);"
            d="M 30.474 188.519 C 30.474 188.519 40.264 211.427 120.735 211.606 C 201.206 211.785 205.258 188.285 205.258 188.285"
            transform="matrix(-1, 0, 0, -1, 235.731995, 399.892029)"
        />
        <path
            style="fill: rgb(216, 216, 216); stroke: rgb(0, 0, 0); stroke-width: 3px; fill-opacity: 0;"
            d="M 28.585 215.782 C 28.585 215.782 30.814 245.383 117.833 244.312 C 204.852 243.241 207.399 215.831 207.399 215.831"
        />
        <g
            id="g-1"
            transform="matrix(0, 1, -0.478148, 0, 244.683273, -85.919296)"
            style="stroke: rgb(0, 0, 0);"
        >
            <line x1="345" y1="80" x2="375" y2="80" id="line-1" />
            <line x1="345" y1="260" x2="375" y2="260" id="line-2" />
            <line
                x1="368"
                y1="80"
                x2="368"
                y2="260"
                id="line-3"
                style="marker-start:url(#seta3);marker-end:url(#seta4)"
            />
        </g>
        <text
            x="152.09"
            y="269.849"
            style="font-size: 18.8px; font-family: Tahoma; white-space: pre;"
            id="text-1">{r}</text
        >
    </svg>
</div>

<style>
    svg {
        max-width: 50%;
        /* width: auto; */
        /* height: auto; */
    }
</style>
